import { Action } from 'redux';

import { DeleteFlowDraft } from '../../app/actions/AppActionTypes';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ISpaceItemDetailInfo } from '../../ts/models/ISpaceItemDetailInfo';

export type FlowForDeleteDraft = IContentInfo<'flow'> | ISpaceItemDetailInfo<'flow'>;

export interface DeleteFlowDraftReduxAction extends Action {
  readonly flows: ReadonlyArray<FlowForDeleteDraft>;
}

export function deleteFlowDraft(flows: ReadonlyArray<FlowForDeleteDraft>): DeleteFlowDraftReduxAction {
  return {
    type: DeleteFlowDraft,
    flows
  };
}
